// extracted by mini-css-extract-plugin
export var avatarContainer = "_50-1";
export var largeAvatarContainer = "_50-2";
export var smallAvatarContainer = "_50-0";